import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { OrderItemInput } from '../../graphql';
import { moneyToCents } from '../moneyToCents';
import { transModifierToOrderModifierInput } from '../transModifierToOrderModifierInput';

export const transItemToOrderItemInput = (
	input: Percomatic.Serialized.TransItem
): OrderItemInput => ({
	id: input.id,
	itemId: input.item.id,
	price: moneyToCents(input.price),
	taxAmount: moneyToCents(input.taxAmount),
	taxRate: input.taxRate,
	modifiers: input.modifiers.map(transModifierToOrderModifierInput)
});
